function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff;opacity:.046}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "prefix__Efeito",
  transform: "translate(-266 -104)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "prefix__Elipse",
  cx: 66.5,
  cy: 66.5,
  r: 66.5,
  className: "prefix__cls-1",
  transform: "translate(266 104)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "prefix__Elipse-2",
  cx: 66.5,
  cy: 66.5,
  r: 66.5,
  className: "prefix__cls-1",
  "data-name": "Elipse",
  transform: "rotate(-90 261.5 -4.5)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "prefix__Elipse-3",
  cx: 66.5,
  cy: 66.5,
  r: 66.5,
  className: "prefix__cls-1",
  "data-name": "Elipse",
  transform: "rotate(-90 261.5 -24.5)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "prefix__Elipse-4",
  cx: 66.5,
  cy: 66.5,
  r: 66.5,
  className: "prefix__cls-1",
  "data-name": "Elipse",
  transform: "translate(286 124)"
}));

var SvgEffectImageOutline = function SvgEffectImageOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 153 153",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEffectImageOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/effect-image-outline.370a3d1e.svg";
export { ForwardRef as ReactComponent };